import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '@mui/material';
import { useStyles } from './dz-autocomplete-list-skeleton.styles';
export const DzSkeletonList = () => {
    const classes = useStyles();
    return (_jsxs(_Fragment, { children: [_jsx(Skeleton, { variant: "rectangular", className: classes.marginBottomSkeleton }), _jsx(Skeleton, { variant: "rectangular", className: classes.marginBottomSkeleton }), _jsx(Skeleton, { variant: "rectangular", className: classes.marginBottomSkeleton })] }));
};
